// extracted by mini-css-extract-plugin
export default {"container":"Chat_container__wWDTF","chat_container":"Chat_chat_container__YQzKm","line":"Chat_line__4Pxnj"};